//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import UserSelect from '~/components/UserSelect.vue';
import EditModal from './UserLeads/UserLeadsEditModal.vue';
import constant from '~/const';

export default {
  components: { UserSelect, EditModal },
  data() {
    return {
      traderLeads: [],
      addingLead: {},
      leadToEdit: {},
      editingLeadModal: false,
      constant,
    };
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('common', ['generalLoader']),
    ...mapState('referrals', ['referrals']),

    referralPayload() {
      const { id, roles } = this.user;
      if (roles.includes(this.constant.users.USER_ROLE.TRADER)) return { traderId: id };
      if (roles.includes(this.constant.users.USER_ROLE.TRADER_LEAD)) return { leadId: id };
      return null;
    },

    userModel: {
      get() {
        return this.addingLead.user;
      },
      set(value) {
        this.addingLead.user = value;
      },
    },

    isTrader() {
      return this.user?.roles[0] === this.constant.users.USER_ROLE.TRADER;
    },
  },
  methods: {
    ...mapActions('common', [
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'setGeneralLoader',
      'confirmAction',
    ]),
    ...mapActions('referrals', {
      loadLeads: 'loadTraderLeadReferrals',
      addNewReferral: 'addReferral',
      editReferral: 'editReferral',
    }),

    openEditModal(lead) {
      this.leadToEdit = lead;
      this.editingLeadModal = true;
    },

    async addLead() {
      const { payInPercentage, payOutPercentage, user } = this.addingLead;
      const { id } = user;

      this.traderLeads.push({ id, payInPercentage, payOutPercentage });
      this.setGeneralProgress(true);
      try {
        await this.addNewReferral({
          traderId: this.user.id,
          leadId: user.id,
          payInPercentage,
          payOutPercentage,
        });
        await this.loadLeads(this.referralPayload);
        this.setSuccessNotification('Lead successfully added');
        this.addingLead = {};
      } catch (error) {
        this.setErrorNotification(error.message);
      }
      this.setGeneralProgress(false);
    },
    async editFees({ id, payInPercentage, payOutPercentage }) {
      this.setGeneralProgress(true);
      try {
        await this.editReferral({
          id,
          payInPercentage,
          payOutPercentage,
        });
        await this.loadLeads(this.referralPayload);
        this.setSuccessNotification('Lead successfully edited');
        this.editingLeadModal = false;
      } catch (error) {
        this.setErrorNotification(error.message);
      }
      this.setGeneralProgress(false);
    },
  },
};
